import { Controller } from 'stimulus';
import autocomplete from 'autocompleter';

export default class extends Controller {
  inputTarget: HTMLInputElement;
  sourceValue: string[];

  static get targets() {
    return ['input'];
  }

  static get values() {
    return { source: Array };
  }

  connect() {
    autocomplete({
      input: this.inputTarget,
      className: 'dropdown open',
      minLength: 0,
      emptyMsg: '',
      fetch: (text, update) => {
        const query = text.toLowerCase();
        update(
          this.sourceValue
            .filter((item) => item.toLowerCase().includes(query))
            .map((item) => ({ label: item, value: item }))
        );
      },
      onSelect: (item) => {
        this.inputTarget.value = item.label;
      },
      preventSubmit: 2,
      showOnFocus: true
    });
  }
}
